import "./VideoWork.module.css";
import Header from "@/reusable_sections/Header";
import StaticAlbumGallery from "./sections/StaticAlbumGallery";
import Footer from "@/reusable_sections/Footer";
export default function VideoWorkPage() {
  return <div>
      <Header />
      <StaticAlbumGallery />
      <Footer />
    </div>;
}